import whenDomReady from 'when-dom-ready';
import anime from 'animejs';
class Svg {
    constructor(svg) {
        this.svg = svg;
        this.paths = Array.from(this.svg.querySelectorAll('path'));
        const callback = (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    if (this.svg.classList.contains('animated-svg')) {
                        return;
                    }
                    this.svg.classList.add('animated-svg');
                    this.paths.forEach((path) => {
                        const animation = anime({
                            targets: path,
                            strokeDashoffset: [0, anime.setDashoffset],
                            easing: 'easeInOutSine',
                            direction: 'reverse',
                            duration: 1500,
                        });
                        animation.play;
                    });
                }
            });
        };
        const observer = new IntersectionObserver(callback, {
            rootMargin: '60px',
            threshold: 0.2,
        });
        observer.observe(this.svg);
    }
}
function initialize() {
    const svgs = Array.from(document.querySelectorAll('[data-anim-svg] svg'));
    if (svgs.length === 0) {
        return;
    }
    svgs.forEach(svg => {
        // eslint-disable-next-line no-new
        new Svg(svg);
    });
}
whenDomReady().then(initialize);
